var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyp1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_725_3370)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5283 6.21862L5.66851 13.2245C4.53455 12.4373 -0.568254 7.16323 3.56259 1.18072L3.80558 0.787133L4.21056 0.550982C4.85854 0.157396 6.23548 0.0786784 7.12645 0.472264C5.8305 2.51891 6.39748 3.3848 7.77443 4.17197L10.7713 5.82503L10.5283 6.21862ZM4.61555 3.22737C4.85854 4.17197 5.50651 4.95915 6.55947 5.58888L8.5034 6.69092L5.7495 10.6268C3.88657 8.18655 3.48159 5.82503 4.61555 3.22737Z",
    fill: "#BC7800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9006 10.3907L14.0938 18.0262C15.3087 18.5772 22.5984 20.2303 25.8383 13.7755L26.0813 13.3819V12.9096C26.0813 12.1224 25.5143 10.9417 24.7043 10.3907C23.5704 12.4373 22.5174 12.4373 21.0595 11.6501L18.0626 9.99707L17.9006 10.3907ZM23.4894 13.8542C22.5174 14.0904 21.4645 13.9329 20.4115 13.3819L18.4676 12.2799L16.2807 16.5306C19.4395 16.9242 21.7885 16.0583 23.4894 13.8542Z",
    fill: "#BC7800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5283 6.21863L5.66851 13.2245C4.53455 12.4373 -0.568254 7.16324 3.56259 1.18073L3.80558 0.787147C4.53455 0.550996 5.50651 0.472278 6.39748 0.944582C5.58751 2.36149 5.9115 3.62097 7.36944 4.40814L10.5283 6.21863ZM8.5034 6.69094L6.55947 5.5889C5.10153 4.80172 4.45355 3.62097 4.53455 2.28277C3.2386 4.32942 3.07661 6.5335 3.96757 8.73759C4.29156 9.60347 4.85854 10.3906 5.42552 11.0991L8.5034 6.69094Z",
    fill: "url(#paint0_linear_725_3370)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5296 6.21865L10.7726 5.82506L7.7757 4.172C6.39876 3.38483 5.83178 2.51894 7.12773 0.47229L6.39876 0.944593C5.58879 2.3615 5.91277 3.62098 7.37072 4.40815L10.5296 6.21865Z",
    fill: "url(#paint1_linear_725_3370)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.61561 3.22744C4.53461 2.91257 4.53461 2.59771 4.53461 2.28284C3.23866 4.32948 3.07667 6.53357 3.96764 8.73765C4.29162 9.60354 4.8586 10.3907 5.42558 11.1779L5.74957 10.7056C3.88664 8.18663 3.48165 5.82511 4.61561 3.22744Z",
    fill: "url(#paint2_linear_725_3370)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.80664 0.865903C4.53561 0.629751 5.50758 0.551034 6.39854 1.02334L7.12751 0.551034C6.23655 0.0787309 4.9406 0.236165 4.21163 0.629751L3.80664 0.865903Z",
    fill: "url(#paint3_linear_725_3370)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9006 10.3906L14.0938 18.0262C15.3087 18.5772 22.5984 20.2303 25.8383 13.7755L26.0813 13.3819C25.9193 12.6734 25.5143 11.8075 24.7043 11.2565C23.8944 12.5947 22.5984 12.9883 21.1405 12.2011L17.9006 10.3906ZM18.4676 12.2798L20.4115 13.3819C21.8695 14.1691 23.2464 14.1691 24.3804 13.4606C23.1654 15.586 21.3025 16.8454 18.8726 17.1603C17.9006 17.3177 16.9286 17.239 16.0377 17.1603L18.4676 12.2798Z",
    fill: "url(#paint4_linear_725_3370)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9004 10.3907L18.0624 9.99707L21.0593 11.6501C22.4362 12.4373 23.4892 12.4373 24.7041 10.3907V11.2565C23.8942 12.5947 22.5982 12.9883 21.1403 12.2012L17.9004 10.3907Z",
    fill: "url(#paint5_linear_725_3370)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4878 13.8543C23.8118 13.7756 24.1358 13.6181 24.3788 13.4607C23.1638 15.5861 21.3009 16.8455 18.871 17.1604C17.899 17.3178 16.927 17.2391 15.9551 17.1604L16.1981 16.6094C19.4379 16.9243 21.7869 16.0584 23.4878 13.8543Z",
    fill: "url(#paint6_linear_725_3370)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6095 25.1108L9.71852 26.6852C9.23253 27.4723 6.72163 26.8426 4.04873 25.347C1.37584 23.8513 -0.406095 22.0408 0.0798862 21.2537L0.970852 19.6793L10.6095 25.1108Z",
    fill: "url(#paint7_linear_725_3370)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6101 25.1108C10.1241 25.898 7.6132 25.2683 4.9403 23.7726C2.3484 22.277 0.56647 20.4665 0.971454 19.6793C1.78142 18.2624 3.23937 18.656 4.9403 18.8134C5.75027 18.8922 6.47924 18.7347 6.88423 17.9476L7.37021 17.0817L8.50416 17.7114L9.63812 18.3411L9.15214 19.207C8.74716 19.9155 8.99015 20.6239 9.39513 21.2537C10.3671 22.7493 11.501 23.6939 10.6101 25.1108Z",
    fill: "url(#paint8_linear_725_3370)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.45698 19.9942C2.26695 18.5773 3.5629 18.8922 5.18284 18.9709C5.91181 18.9709 6.55978 18.8135 7.04576 18.105C7.20776 17.7901 7.36975 17.554 7.53175 17.2391L7.45075 17.1604L6.96477 18.0263C6.55978 18.7347 5.74981 18.8922 5.02084 18.8922C3.23891 18.7347 1.86196 18.2624 0.970998 19.6794C0.809004 19.9155 0.890001 20.2304 1.13299 20.624C1.21399 20.3878 1.37598 20.1517 1.45698 19.9942Z",
    fill: "url(#paint9_radial_725_3370)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07039 21.0963C9.79936 22.3557 10.6903 23.2216 9.88036 24.6385C9.71836 24.8747 9.55637 25.1108 9.47537 25.347C10.0424 25.4257 10.5283 25.2683 10.6903 25.0321C11.5003 23.6152 10.4473 22.6706 9.47537 21.2537C9.07039 20.624 8.8274 19.9155 9.23238 19.2071L9.71836 18.3412L9.55637 18.2625C9.39438 18.5773 9.23238 18.8135 9.07039 19.1283C8.58441 19.9155 8.7464 20.5452 9.07039 21.0963Z",
    fill: "url(#paint10_radial_725_3370)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.5
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.23379 24.3236C10.0438 22.9067 9.31479 22.1195 8.74781 20.9388C8.50482 20.3878 8.42382 19.758 8.82881 19.0496C8.9908 18.7347 9.15279 18.4985 9.31479 18.1837L8.9908 18.0262C8.82881 18.3411 8.66681 18.5773 8.50482 18.8921C8.09983 19.6006 8.01884 20.1516 8.09983 20.6239C8.26183 21.5685 8.66681 22.1983 7.77585 23.6152C7.53286 24.0088 7.28987 24.4811 7.04688 24.8746C7.61385 25.1108 8.09984 25.2682 8.58582 25.3469C8.9098 24.9534 9.0718 24.6385 9.23379 24.3236Z",
    fill: "url(#paint11_radial_725_3370)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.85948 21.8833C5.66945 20.4664 6.15543 20.309 6.8034 19.8367C7.12739 19.6005 7.45138 19.207 7.85636 18.4985C8.01836 18.1836 8.18035 17.9475 8.34234 17.6326L7.85636 17.3177C7.69437 17.6326 7.53238 17.8688 7.37038 18.1836C6.9654 18.8921 6.39842 19.207 5.83144 19.2857C4.61649 19.5218 3.72552 19.3644 2.91555 20.7813C2.67256 21.1749 2.51057 21.4898 2.26758 21.8833C2.75356 22.3556 3.32054 22.7492 4.04951 23.2215C4.2925 22.7492 4.53549 22.2769 4.85948 21.8833Z",
    fill: "url(#paint12_radial_725_3370)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.971338 19.6793L0.0803725 21.2537C-0.0816213 21.4898 -0.00062439 21.8047 0.242366 22.1983L1.13333 20.6239C0.890341 20.2303 0.809345 19.9155 0.971338 19.6793Z",
    fill: "url(#paint13_linear_725_3370)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4769 25.4257L8.58594 27.0001C9.15292 27.0788 9.6389 26.9213 9.80089 26.6852L10.6919 25.1108C10.4489 25.347 10.0439 25.5044 9.4769 25.4257Z",
    fill: "url(#paint14_linear_725_3370)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9006 10.3906L14.0938 18.0262C14.4177 18.1836 15.1467 18.3411 16.0377 18.4985C16.8476 18.1836 17.6576 17.7113 18.3866 17.1603C17.6576 17.239 16.8476 17.1603 16.1187 17.0816L18.5486 12.2798L20.4925 13.3819C21.0595 13.6967 21.5455 13.8542 22.0314 13.9329C22.1124 13.8542 22.1934 13.7755 22.2744 13.618L23.2464 12.4373C22.5984 12.6734 21.8695 12.5947 21.0595 12.1224L17.9006 10.3906Z",
    fill: "url(#paint15_radial_725_3370)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.31442 19.0496C9.23343 19.207 8.66645 19.0496 8.01847 18.656C7.45149 18.2624 7.04651 17.7114 7.12751 17.5539L7.4515 17.0029L9.63841 18.4986L9.31442 19.0496Z",
    fill: "url(#paint16_radial_725_3370)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77463 2.83386L14.9834 6.92716L22.1921 11.0205L20.7341 12.8309C17.8992 16.4519 12.5534 20.7027 8.17962 18.2624C3.80579 15.8222 4.93974 9.20996 6.72167 4.95923L7.77463 2.83386Z",
    fill: "url(#paint17_linear_725_3370)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.75
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.01768 2.99121L13.8495 6.29733L19.6812 9.60346L18.4663 11.2565C16.1174 14.4839 11.6625 18.3411 8.09868 16.2944C4.61581 14.3265 5.66877 8.58013 7.20771 4.88042L8.01768 2.99121Z",
    fill: "url(#paint18_radial_725_3370)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.75
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50339 3.30615L12.9582 5.74639L17.4131 8.26534L16.4411 9.68225C14.4972 12.4373 10.8523 15.7435 8.09841 14.2478C5.42551 12.7522 6.39748 7.95047 7.77442 4.8805L8.50339 3.30615Z",
    fill: "url(#paint19_radial_725_3370)"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26165 18.2624C4.3738 16.0584 5.66975 9.60354 7.53268 5.43153C7.85667 4.72308 8.18065 4.01462 8.50464 3.30617L7.77567 2.83386L6.80371 4.95923C5.02177 9.20996 3.88782 15.8222 8.26165 18.2624Z",
    fill: "url(#paint20_radial_725_3370)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8432 12.2799C17.0893 15.9796 11.9865 20.3877 8.17969 18.2624C12.5535 20.7026 17.8993 16.4519 20.7342 12.8309L22.1921 11.0204L21.2202 10.4694C20.8152 11.0991 20.3292 11.7288 19.8432 12.2799Z",
    fill: "url(#paint21_radial_725_3370)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.6
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26172 18.2624C11.4206 19.9942 16.1184 15.4286 18.7913 11.7289C19.2773 11.0992 19.6823 10.4694 20.1683 9.83969L18.1433 8.65894C17.7384 9.28867 17.2524 9.91841 16.8474 10.5481C14.2555 14.4053 10.1246 19.3645 8.26172 18.2624Z",
    fill: "url(#paint22_radial_725_3370)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26096 18.2624C7.37 17.7901 10.2049 12.1225 12.3918 8.10791C12.7968 7.39946 13.1208 6.76972 13.5258 6.06126L10.6099 4.4082C10.2859 5.11666 9.9619 5.7464 9.55691 6.45485C7.61299 10.6269 5.66906 16.8455 8.26096 18.2624Z",
    fill: "url(#paint23_radial_725_3370)"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6875 9.1312C10.2856 7.24199 7.77469 4.88047 7.5317 3.46356C7.36971 2.67639 8.34167 1.25948 8.74666 0.551025L16.2794 4.80175L23.8121 9.05248C23.4071 9.76094 22.5971 11.3353 21.8682 11.5714C20.4102 12.0437 17.0893 11.0991 13.6875 9.1312Z",
    fill: "url(#paint24_radial_725_3370)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9581 8.50145C10.1232 6.76967 8.09826 4.72302 7.85527 3.46355C7.77427 2.83381 8.58424 1.65305 8.90823 1.02332L15.064 4.80174L21.2198 8.58017C20.8148 9.2099 20.1668 10.4694 19.5998 10.7055C18.4659 11.0991 15.793 10.2332 12.9581 8.50145Z",
    fill: "url(#paint25_radial_725_3370)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1496 7.63555C9.9627 6.13992 8.34276 4.40814 8.18077 3.46354C8.09977 2.91252 8.74775 1.96791 9.07174 1.49561L13.9315 4.72301L18.7914 7.95042C18.4674 8.42272 17.9814 9.44604 17.4954 9.60348C16.5234 9.91835 14.4175 9.13117 12.1496 7.63555Z",
    fill: "url(#paint26_radial_725_3370)"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.812 9.05249C23.569 9.52479 22.7591 9.68223 21.7871 9.60351L21.2201 10.4694L20.4102 11.6502C20.9771 11.7289 21.4631 11.6502 21.8681 11.5714C22.5971 11.2566 23.326 9.76095 23.812 9.05249Z",
    fill: "url(#paint27_radial_725_3370)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58466 3.38486L9.15164 2.36154C8.66566 1.65308 8.50367 1.02335 8.74666 0.629761C8.34167 1.33822 7.36971 2.75513 7.5317 3.46358C7.5317 3.62101 7.6127 3.77845 7.6937 3.93588C7.77469 4.09332 7.85569 4.32947 8.01769 4.4869L8.58466 3.38486Z",
    fill: "url(#paint28_radial_725_3370)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.65
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9806 8.5802L16.7656 10.6268C17.3326 10.863 17.9806 11.0992 18.4666 11.2566C18.6286 11.3353 18.7905 11.3353 19.0335 11.414L20.0055 9.76096L20.2485 9.28866C19.6005 9.13122 18.8715 8.89507 17.9806 8.5802Z",
    fill: "url(#paint29_radial_725_3370)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5256 6.21868C12.5536 5.58894 11.6627 4.95921 10.9337 4.32947L9.71875 6.37612C10.4477 7.00585 11.3387 7.63559 12.3107 8.34405L13.5256 6.21868Z",
    fill: "url(#paint30_radial_725_3370)"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5753 2.59773C21.7061 4.88053 24.379 7.79306 23.65 9.05254C22.9211 10.312 18.9522 9.52484 14.8214 7.16333C10.6905 4.88053 8.01765 1.96799 8.74662 0.708515C9.47559 -0.55096 13.4444 0.236212 17.5753 2.59773Z",
    fill: "#FFFCE4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5754 2.51896C21.7062 4.88047 24.5411 7.79301 23.7312 8.97377C23.0022 10.2332 19.0333 9.36735 14.8215 7.00584C10.6907 4.64432 7.85578 1.73178 8.66575 0.551027C9.47572 -0.708449 13.4446 0.236158 17.5754 2.51896Z",
    fill: "url(#paint31_radial_725_3370)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.495 2.67635C21.3828 4.88043 24.0557 7.55681 23.3267 8.65885C22.6788 9.76089 18.9529 8.895 15.0651 6.69092C11.1772 4.48684 8.5043 1.81046 9.23328 0.708416C9.88125 -0.393625 13.6071 0.472265 17.495 2.67635Z",
    fill: "url(#paint32_radial_725_3370)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1986 2.20414C19.1145 3.8572 21.0584 5.98257 21.3824 7.63563C21.4634 8.10793 21.4634 8.58023 21.2204 8.97382C21.2204 8.97382 21.2204 9.05254 21.1394 9.05254C22.1924 9.20997 23.0024 9.13126 23.3263 8.65895C23.3263 8.65895 23.3263 8.58023 23.4073 8.58023C24.0553 7.47819 21.4634 4.80181 17.5756 2.59773C14.3357 0.787232 11.1768 -0.157375 9.88086 0.236211C11.5008 0.236211 13.8497 0.944666 16.1986 2.20414Z",
    fill: "url(#paint33_radial_725_3370)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3046 8.26532C18.4666 7.39943 17.8186 6.13995 16.6037 4.95919C15.7937 4.17202 14.7407 3.38485 13.5258 2.67639C12.3108 1.96794 11.0959 1.49564 9.96191 1.25949C9.71892 1.18077 9.39493 1.10205 9.15194 1.10205C8.98995 2.36153 11.5008 4.72304 15.0647 6.76969C16.1987 7.39943 17.2516 7.87173 18.3046 8.26532Z",
    fill: "url(#paint34_radial_725_3370)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.12967 20.1516C4.85864 20.7026 5.34462 21.3323 5.18263 21.6472C5.02063 21.9621 4.29166 21.7259 3.56269 21.2536C2.83372 20.7026 2.34774 20.0729 2.50973 19.758C2.67172 19.4431 3.4007 19.6793 4.12967 20.1516Z",
    fill: "url(#paint35_radial_725_3370)"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.96842 1.41688C4.3734 1.02329 5.66935 1.25945 5.83135 1.65303C5.91234 1.88918 5.75035 2.4402 6.07434 2.99122C5.83135 2.4402 5.99334 1.73175 6.39832 0.944578C5.50736 0.550992 4.5354 0.629709 3.80642 0.86586L3.56343 1.18073C2.26748 2.99122 1.8625 4.80172 1.9435 6.37606C2.02449 4.40813 3.23945 2.04662 3.96842 1.41688Z",
    fill: "url(#paint36_radial_725_3370)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99275 0.629688C5.18278 0.550971 4.6968 0.629688 4.04883 0.787123C4.6968 0.629688 5.58777 0.629688 6.39774 1.02327L7.12671 0.550971C6.96472 0.393537 6.72173 0.314819 6.39774 0.314819C6.47873 0.393537 6.55973 0.550971 6.47873 0.550971C6.31674 0.629688 6.07375 0.629688 5.99275 0.629688Z",
    fill: "url(#paint37_radial_725_3370)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.18259 9.83969C5.18259 9.99712 5.10159 10.2333 4.8586 9.99712C3.48165 8.89508 3.15767 5.98255 3.64365 4.4082C3.72464 4.25077 3.88664 3.69975 4.04863 3.77846C4.12963 3.85718 4.21063 4.01462 4.21063 4.17205C4.29162 3.85718 4.45362 3.54231 4.53461 3.22744C4.53461 2.91257 4.53461 2.59771 4.53461 2.28284C3.23866 4.32948 3.07667 6.53357 3.96764 8.73765C4.21063 9.36739 4.53461 9.91841 4.9396 10.4694C5.02059 10.6269 5.18259 10.7843 5.26358 10.9417C5.26358 10.6269 5.34458 10.3907 5.34458 10.0758C5.34458 9.99712 5.26359 9.91841 5.18259 9.83969Z",
    fill: "url(#paint38_radial_725_3370)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3323 16.6094C17.1703 16.6881 17.0083 16.8455 17.3323 16.9242C19.0332 17.554 21.7871 16.3732 22.921 15.1925C23.002 15.1138 23.407 14.6415 23.245 14.5627C23.164 14.484 23.002 14.5627 22.84 14.6415C23.083 14.4053 23.326 14.1691 23.488 13.8543C23.812 13.7756 24.136 13.6181 24.379 13.4607C23.164 15.5861 21.3011 16.8455 18.8712 17.1604C18.2232 17.2391 17.4942 17.2391 16.8463 17.2391C16.6843 17.2391 16.4413 17.2391 16.2793 17.1604C16.5223 17.003 16.7653 16.8455 17.0083 16.6881C17.0893 16.6094 17.2513 16.6094 17.3323 16.6094Z",
    fill: "url(#paint39_radial_725_3370)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0298 12.0438C21.8678 12.0438 21.7058 11.9651 21.5438 11.8864L21.3008 12.2799C22.0298 12.5948 22.6777 12.6735 23.2447 12.4374C23.0827 12.5161 22.0298 12.5161 21.9488 12.2012C21.9488 12.1225 21.9488 12.1225 22.0298 12.0438Z",
    fill: "url(#paint40_linear_725_3370)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88315 3.5423C7.04515 3.69973 7.12614 3.77845 7.28814 3.85717L7.12614 4.32947C6.47817 3.85717 6.07318 3.38486 5.99219 2.75513C5.99219 2.91256 6.55917 3.77845 6.80216 3.69973C6.88315 3.69973 6.88315 3.62102 6.88315 3.5423Z",
    fill: "url(#paint41_linear_725_3370)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_725_3370",
    x1: 2.543,
    y1: 0.161031,
    x2: 8.45516,
    y2: 11.9699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B36600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_725_3370",
    x1: 7.83321,
    y1: 0.443322,
    x2: 8.34575,
    y2: 4.33129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB7D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_725_3370",
    x1: 3.63296,
    y1: 2.41902,
    x2: 4.98117,
    y2: 10.9195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C77000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4033,
    stopColor: "#CC8B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA5E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_725_3370",
    x1: 3.81879,
    y1: 0.623769,
    x2: 7.14501,
    y2: 0.623769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B36600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_725_3370",
    x1: 13.8796,
    y1: 15.8511,
    x2: 37.8591,
    y2: 8.31642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B35100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_725_3370",
    x1: 20.8989,
    y1: 11.0975,
    x2: 24.2652,
    y2: 9.6646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B86800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_725_3370",
    x1: 16.3109,
    y1: 17.5533,
    x2: 24.4684,
    y2: 13.7929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C75A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4033,
    stopColor: "#BF6D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_725_3370",
    x1: 0.1135,
    y1: 21.1572,
    x2: 9.62432,
    y2: 26.8074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00743494,
    stopColor: "#781916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#963333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#450E0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_725_3370",
    x1: 1.95476,
    y1: 18.059,
    x2: 11.4656,
    y2: 23.7091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520446,
    stopColor: "#ED9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4033,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9257,
    stopColor: "#B36600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.63183 21.5532) scale(6.23303 6.05761)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08F48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.06651 24.7658) scale(6.51393 6.33059)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08F48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.18523 22.2278) scale(4.49954 4.3729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.58888 19.5751) scale(4.50092 4.37424)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_725_3370",
    x1: 0.341911,
    y1: 20.7736,
    x2: 0.842488,
    y2: 21.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6029,
    stopColor: "#C3C7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_725_3370",
    x1: 9.21545,
    y1: 25.8317,
    x2: 9.94711,
    y2: 26.2664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3971,
    stopColor: "#C3C7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#616DBE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1095 10.6709) scale(8.86219 8.61276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "#E08F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.08042 17.2786) scale(3.8186 3.71112)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "#FFA163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_725_3370",
    x1: 4.37916,
    y1: 8.54369,
    x2: 18.6616,
    y2: 17.0284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520446,
    stopColor: "#ED9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4033,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D96D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.50229 5.25488) scale(13.8278 13.4386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.48475 3.97053) scale(11.0261 10.7158)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8215 10.2219) scale(11.6338 11.3064)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08F48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.9677 11.2761) scale(10.0584 9.77526)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08F48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8669 5.79292) scale(13.204 12.8324)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.10434 4.95584) scale(13.9214 13.5296)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.87648 5.60963) scale(13.685 13.2998)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED9500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.1024 -1.63056) scale(13.3519 12.9761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.2489 0.561626) scale(9.45242 9.18638)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.6017 8.63545) scale(5.69408 5.53382)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA163"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5142 4.22792) scale(5.81639 5.65268)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA163"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.6252 7.33891) scale(5.39723 5.24532)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.13193 3.77404) scale(7.12838 6.92774)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.64769 3.38091) scale(19.8691 19.3099)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9C0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.523 1.19512) scale(10.3366 10.0457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.6402 8.84866) scale(13.2033 12.8317)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    stopColor: "#211F0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#746E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9707,
    stopColor: "#F7EB66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF369"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.57007 8.78202) scale(11.7458 11.4153)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "#E08F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.41916 19.2306) scale(3.91247 3.80236)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.6523 -0.638662) scale(8.7032 8.45824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.88835 -0.259344) scale(3.02774 2.94253)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077724,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2193,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3612,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5001,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7659,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8898,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF369"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.4079 6.57938) scale(5.80974 5.64623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08F48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_725_3370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.3855 11.6136) scale(7.79166 7.57236)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08F48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_725_3370",
    x1: 21.2695,
    y1: 12.224,
    x2: 23.1971,
    y2: 12.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "#E08F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_725_3370",
    x1: 7.31859,
    y1: 4.39536,
    x2: 6.05928,
    y2: 2.65276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "#E08F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_725_3370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 27,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyp1);
export default __webpack_public_path__ + "static/media/myp_1.e16a270e4f9692c1baa100bd2b15bc49.svg";
export { ForwardRef as ReactComponent };